var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMusicIcon = function SvgMusicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.852.805-8.75 2.57a.914.914 0 0 0-.602.848v7.136a9.538 9.538 0 0 0-.875-.109C1.175 11.25 0 12.043 0 13c0 .984 1.176 1.75 2.625 1.75 1.45 0 2.625-.766 2.625-1.75V6.629l7-2.05v5.03a9.556 9.556 0 0 0-.875-.109c-1.45 0-2.625.793-2.625 1.75 0 .984 1.176 1.75 2.625 1.75 1.45 0 2.625-.766 2.625-1.75V1.625c-.027-.465-.41-.848-.875-.848-.11 0-.191 0-.273.028Z",
    fill: "currentColor"
  })));
};
export default SvgMusicIcon;